import React from 'react';

const Tos = () => {
  return (
    <div className='legal-page'>
      <div className="container">
        <h1>Terms of Service</h1>
        <h2>Acceptance of Terms:</h2>
        <p>
          By using Harmabot(the Bot), you acknowledge that you have read, understood, and agree to comply with these Terms.
        </p>

        <h2>Use of the Harambot:</h2>
        <ul>
          <li>Eligibility: You must be at least 13 years old to use the Bot. If you are under the age of 13, you may not use the Bot.</li>
          <li>License: The Bot is distributed under the terms of the MIT License. By using the Bot, you acknowledge that you have read, understood, and agree to comply with the MIT License terms.</li>
          <li>Permissible Use: You may use the Bot in accordance with the permissions granted by the MIT License. This includes the freedom to use, modify, distribute, or sublicense the Bot's source code, subject to the MIT License's terms. You are encouraged to review the full text of the MIT License for a complete understanding of your rights and obligations.</li>
        </ul>

        <h2>API Access:</h2>
        <ul>
          <li>Authentication: To use the Bot, you must provide valid authentication credentials for Yahoo's Fantasy Sports API, including an API key if required. You are solely responsible for maintaining the confidentiality of your credentials.</li>
          <li>Data Usage: You agree to use the Yahoo Fantasy Sports API data obtained through the Bot in compliance with Yahoo's Fantasy Sports API Terms of Service and Privacy Policy.</li>
        </ul>

        <h2>Disclaimer of Warranty:</h2>
        <p>
          The Bot and any information obtained through the Bot are provided "as-is" without any warranties, express or implied. We make no representations or warranties regarding the accuracy, completeness, or reliability of the Bot or the data it provides.
        </p>

        <h2>Limitation of Liability:</h2>
        <p>
          In no event shall we be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from your use of the Bot or Yahoo's Fantasy Sports API.
        </p>

        <h2>Termination:</h2>
        <p>
          We reserve the right to terminate or suspend your access to the Bot at any time, with or without cause, and without notice. Upon termination, all licenses and rights granted to you under these Terms will immediately cease.
        </p>

        <h2>Changes to Terms:</h2>
        <p>
          We may update these Terms at any time by posting the revised Terms on this page. Your continued use of the Bot after any such changes constitutes your acceptance of the new Terms.
        </p>

        <h2>Governing Law:</h2>
        <p>
          These Terms are governed by and construed in accordance with the laws of New Jersey, USA, without regard to its conflict of law principles.
        </p>

        <h2>Contact Information:</h2>
        <p>
          If you have any questions or concerns about these Terms or the Bot, please contact us at harambot@harambot.io.
        </p>
      </div>
    </div>
  );
};

export default Tos;
